export enum ECardView {
	GRID = 'grid',
	LIST = 'list',
}
